





















/* General */
import Vue from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersImg,
  ContentPlaceholdersText,
} from 'vue-content-placeholders'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  components: {
    ContentPlaceholders,
    ContentPlaceholdersImg,
    ContentPlaceholdersText,
  },
})
